import React, { useState } from 'react';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import { useNCZIContext } from '../../../Services/NCZIContext';
import { useEffectAsync } from '../../../../../helpers';
import NCZICommandResult from '../../NCZICommandResult/NCZICommandResult';
import { Theme } from '../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../Components/Button/LinkButton';
import useNCZIElectronicPrescription from '../../../Hooks/useNCZIElectronicPrescription';
import ElectronicPrescriptionListItem from './ElectronicPrescriptionListItem';
import ElectronicPrescriptionCreateModal from '../Create/ElectronicPrescriptionCreateModal';
import EHRNoItemsFound from '../../EHR/EHRNoItemsFound';

//@ts-ignore
import styles from './ElectronicPrescriptionList.module.scss';

interface Props {
	setIsLoading: (isLoading: boolean) => void;
	workplaceId: string;
}

const ElectronicPrescriptionList: React.FC<Props> = ({ workplaceId }) => {
	const { patientElectronicPrescriptionData, patientIdentifier } =
		useNCZIContext();

	const {
		handleLoadPatientElectronicPrescriptionData,
		// handleFakeLoadPatientElectronicPrescriptionData,
		loadingCommandId,
	} = useNCZIElectronicPrescription();

	const [
		electronicPrescriptionCreateOpen,
		setElectronicPrescriptionCreateOpen,
	] = useState<boolean>(false);

	const handleLoadData = async () => {
		if (!patientElectronicPrescriptionData) {
			await handleLoadPatientElectronicPrescriptionData();
			// await handleFakeLoadPatientElectronicPrescriptionData();
		}
	};

	useEffectAsync(async () => {
		await handleLoadData();
	}, []);

	const handleCloseDetailModal = async (needReload: boolean) => {
		if (needReload) {
			await handleLoadPatientElectronicPrescriptionData();
		}
	};

	const handleCloseElectronicPrescriptionCreate = async (
		needReload: boolean,
	) => {
		setElectronicPrescriptionCreateOpen(false);
		if (needReload) {
			await handleLoadPatientElectronicPrescriptionData();
		}
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.contentWrapper}>
				<div className={styles.controls}>
					<LinkButton
						title='nczi.electronicPrescription.create.title'
						theme={Theme.BLUE}
						onClick={() => setElectronicPrescriptionCreateOpen(true)}
						firstUpper
					/>
				</div>
				<ScrollContainer>
					<div className={styles.content}>
						{!patientElectronicPrescriptionData ? (
							<div className={styles.loadingWrapper}>
								<NCZICommandResult
									commandId={loadingCommandId}
									handleRetryCommand={() =>
										handleLoadPatientElectronicPrescriptionData()
									}
								/>
							</div>
						) : (
							<>
								{!patientElectronicPrescriptionData.length && (
									<EHRNoItemsFound />
								)}
								{patientElectronicPrescriptionData.map(prescriptionItem => (
									<ElectronicPrescriptionListItem
										key={prescriptionItem.CiarovyKod}
										item={prescriptionItem}
										onClose={handleCloseDetailModal}
									/>
								))}
							</>
						)}
					</div>
				</ScrollContainer>
			</div>
			{electronicPrescriptionCreateOpen && (
				<ElectronicPrescriptionCreateModal
					opened
					onClose={handleCloseElectronicPrescriptionCreate}
					workplaceId={workplaceId}
				/>
			)}
		</div>
	);
};

export default ElectronicPrescriptionList;
